import { render, staticRenderFns } from "./webDiscountUseView.vue?vue&type=template&id=064c6c78&"
import script from "./webDiscountUseView.vue?vue&type=script&lang=js&"
export * from "./webDiscountUseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports